module.exports = __webpack_public_path__ + "img/healthcare.cc07d6c8.webp";